// extracted by mini-css-extract-plugin
export default {"zoomWrapper":"zoom_zoomWrapper__jElXY"};